<script>
import contentDataLoaderMixin from '@/store/modules/contentData/content-data-loader';
import propIdMixin from './prop-id-mixin';
import contentParserMixin from './content-parser-mixin';


export default {
	name: 'PageView',
	mixins: [propIdMixin, contentDataLoaderMixin, contentParserMixin],
	data() {
		return {
			contentType: 'pages',
			containerClass: 'page-container',
			contentClass: 'page-content',
		};
	},
	updated() {
		this.updateImages();
	},
	created() {
		this.updateImages();
		this.$emit('alt-background', false);
	},
	methods: {
		updateImages() {
			const page = this.getContentById('pages', this.id);
			if (page.file_id) {
				const media = this.findInMedia(page.file_id);
				if (media) {
					this.$root.$emit('updateCoverImages', [media.original_name]);
				}
			}
		},
	},
};
</script>


<style src="@/styles/views/ContentParserStyles/ContentParserStyles.less" lang="less"></style>
<style src="@/styles/views/PageView/PageView.less" lang="less"></style>

